import Vue from 'vue';
import { getToken } from '@/utils/auth';
import { userLogout } from '@/api/user';
import store from '@/store';
import i18n from '@/lang';

const vv = new Vue();

function connectTester(state) {
  if (state.socket.isConnected) {
    const cmdConnect = {
      cmd: 'CONNECT',
      deviceNames: state.devList,
      token: getToken(),
    };
    console.log('connect', JSON.stringify(state.devList));
    vv.$socket.send(JSON.stringify(cmdConnect));
  }
}

const socketMsg = {
  state: {
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
    },
    devList: [],
  },
  mutations: {
    SOCKET_ONOPEN(state, event) {
      console.log('SOCKET_ONOPEN');
      Vue.prototype.$socket = event.currentTarget;
      state.socket.isConnected = true;
      connectTester(state);
      // webSocketSend(JSON.stringify(cmdConnect));
    },
    SOCKET_ONCLOSE(state, event) {
      console.log('SOCKET_ONCLOSE');
      state.socket.isConnected = false;
    },
    SOCKET_ONERROR(state, event) {
      console.log('SOCKET_ONERROR');
      console.error(state, event);
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
      state.socket.message = message;
      const data = JSON.parse(message.data);
      console.log('SOCKET_ONMESSAGE', data);
      if (data.cmd === 'LOGOUT') {
        vv.$message({
          type: 'error',
          message: i18n.t('login.theCurrentUserLogsInElsewhere'),
          onClose: () => {
            console.warn('22222');
            store.dispatch('loginOut');
          },
        });
        // onClose: () => {
        //   vv.$store.dispatch('loginOut');
        // },
      }
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
      console.log('SOCKET_RECONNECT', count);
    },
    SOCKET_RECONNECT_ERROR(state) {
      console.log('SOCKET_RECONNECT_ERROR');
      state.socket.isConnected = false;
      state.socket.reconnectError = true;
    },
  },
  actions: {
    async loginOut({ commit }) {
      try {
        await userLogout();
        // mutations.removeToken();
        commit('user/removeToken');
        window.location.reload();
      } catch (e) {
        // do nothing.
      }
    },
  },
};

export default socketMsg;
